import { capitalize } from 'lodash';
import { useEffect } from 'react';

import { useRoot } from '../../context/RootProvider';

const PageTitle = () => {
  const { auth } = useRoot();

  useEffect(() => {
    if (auth) {
      document.title = `Escape Plan - ${capitalize(auth?.role)}`;
    } else {
      document.title = `Escape Plan`;
    }
  }, [auth]);

  return null;
};

export default PageTitle;
